export const navBar = [
  {
    id: 1,
    name: "Discover",
    path: "/",
  },
  {
    id: 2,
    name: "Browser",
    path: "/browser",
  },
  {
    id: 3,
    name: "Charts",
    path: "/charts",
  },
  {
    id: 4,
    name: "Artists",
    path: "/artists",
  },
]
export const hero1 = [
  {
    id: 1,
    name: "New Album from Nouvelle",
    tag: "Nouvelle",
    cover: "../images/c1.jpg",
  },
  {
    id: 2,
    name: "Bind Me",
    tag: "Fifty",
    cover: "../images/c2.jpg",
  },
  {
    id: 3,
    name: "New Track from Pablo Nouvelle",
    tag: "Pablo Nouvelle",
    cover: "../images/c3.jpg",
  },
]
export const hero2 = [
  {
    id: 1,
    name: "Pull Up",
    tag: "Summerella",
    cover: "../images/b4.jpg",
  },
  {
    id: 2,
    name: "Fireworks",
    tag: "Kygo",
    cover: "../images/b1.jpg",
  },
  {
    id: 3,
    name: "I Wanna Be In the Cavalry",
    tag: "Jeremy Scott",
    cover: "../images/b2.jpg",
  },
  {
    id: 4,
    name: "What A Time To Be Alive",
    tag: "Judith Garcia",
    cover: "../images/b3.jpg",
  },
]
export const treading = [
  {
    id: 1,
    name: "What A Time To Be Alive",
    tag: "Judith Garcia",
    cover: "../images/b3.jpg",
  },
  {
    id: 2,
    name: "Live Radio",
    tag: "Radionomy",
    cover: "../images/b2.jpg",
  },
  {
    id: 3,
    name: "I Wanna Be In the Cavalry",
    tag: "Jeremy Scott",
    cover: "../images/b5.jpg",
  },
  {
    id: 4,
    name: "Body on me",
    tag: "Rita Ora",
    cover: "../images/b6.jpg",
  },
  {
    id: 5,
    name: "Fireworks",
    tag: "Kygo",
    cover: "../images/b1.jpg",
  },
  {
    id: 6,
    name: "Simple Place To Be",
    tag: "RYD",
    cover: "../images/b7.jpg",
  },
]
export const news = [
  {
    id: 1,
    name: "Simple Place To Be",
    tag: "RYD",
    cover: "../images/b7.jpg",
  },
  {
    id: 2,
    name: "Reflection (Deluxe)",
    tag: "Fifth Harmony",
    cover: "../images/b8.jpg",
  },
  {
    id: 3,
    name: "The Open Road",
    tag: "Postiljonen",
    cover: "../images/b9.jpg",
  },
  {
    id: 4,
    name: "Body on me",
    tag: "Rita Ora",
    cover: "../images/b6.jpg",
  },
  {
    id: 5,
    name: "I Wanna Be In the Cavalry",
    tag: "Jeremy Scott",
    cover: "../images/b2.jpg",
  },
  {
    id: 6,
    name: "Pull Up",
    tag: "Summerella",
    cover: "../images/b4.jpg",
  },
  {
    id: 7,
    name: "What A Time To Be Alive",
    tag: "Judith Garcia",
    cover: "../images/b3.jpg",
  },
  {
    id: 8,
    name: "Live Radio",
    tag: "Radionomy",
    cover: "../images/b5.jpg",
  },
]

export const recommand = [
  {
    id: 1,
    name: "Simple Place To Be",
    tag: "RYD",
    cover: "../images/b1.jpg",
  },
  {
    id: 2,
    name: "Reflection (Deluxe)",
    tag: "Fifth Harmony",
    cover: "../images/b2.jpg",
  },
  {
    id: 3,
    name: "The Open Road",
    tag: "Postiljonen",
    cover: "../images/b3.jpg",
  },
  {
    id: 4,
    name: "Body on me",
    tag: "Rita Ora",
    cover: "../images/b4.jpg",
  },
  {
    id: 5,
    name: "I Wanna Be In the Cavalry",
    tag: "Jeremy Scott",
    cover: "../images/b5.jpg",
  },
  {
    id: 6,
    name: "Pull Up",
    tag: "Summerella",
    cover: "../images/b6.jpg",
  },
  {
    id: 7,
    name: "What A Time To Be Alive",
    tag: "Judith Garcia",
    cover: "../images/b7.jpg",
  },
  {
    id: 8,
    name: "Live Radio",
    tag: "Radionomy",
    cover: "../images/b8.jpg",
  },
  {
    id: 9,
    name: "What A Time To Be Alive",
    tag: "Judith Garcia",
    cover: "../images/b3.jpg",
  },
  {
    id: 10,
    name: "Live Radio",
    tag: "Radionomy",
    cover: "../images/b2.jpg",
  },
]

export const browse = [
  {
    id: 1,
    name: "Simple Place To Be",
    tag: "RYD",
    cover: "../images/b1.jpg",
  },
  {
    id: 2,
    name: "Reflection (Deluxe)",
    tag: "Fifth Harmony",
    cover: "../images/b2.jpg",
  },
  {
    id: 3,
    name: "The Open Road",
    tag: "Postiljonen",
    cover: "../images/b3.jpg",
  },
  {
    id: 4,
    name: "Body on me",
    tag: "Rita Ora",
    cover: "../images/b4.jpg",
  },
  {
    id: 5,
    name: "I Wanna Be In the Cavalry",
    tag: "Jeremy Scott",
    cover: "../images/b5.jpg",
  },
  {
    id: 6,
    name: "Pull Up",
    tag: "Summerella",
    cover: "../images/b6.jpg",
  },
  {
    id: 7,
    name: "What A Time To Be Alive",
    tag: "Judith Garcia",
    cover: "../images/b7.jpg",
  },
  {
    id: 8,
    name: "Live Radio",
    tag: "Radionomy",
    cover: "../images/b8.jpg",
  },
  {
    id: 9,
    name: "What A Time To Be Alive",
    tag: "Judith Garcia",
    cover: "../images/b3.jpg",
  },
  {
    id: 10,
    name: "Live Radio",
    tag: "Radionomy",
    cover: "../images/b2.jpg",
  },
  {
    id: 1,
    name: "Simple Place To Be",
    tag: "RYD",
    cover: "../images/b7.jpg",
  },
  {
    id: 2,
    name: "Reflection (Deluxe)",
    tag: "Fifth Harmony",
    cover: "../images/b8.jpg",
  },
  {
    id: 3,
    name: "The Open Road",
    tag: "Postiljonen",
    cover: "../images/b9.jpg",
  },
  {
    id: 4,
    name: "Body on me",
    tag: "Rita Ora",
    cover: "../images/b6.jpg",
  },
  {
    id: 5,
    name: "I Wanna Be In the Cavalry",
    tag: "Jeremy Scott",
    cover: "../images/b2.jpg",
  },
  {
    id: 6,
    name: "Pull Up",
    tag: "Summerella",
    cover: "../images/b4.jpg",
  },
  {
    id: 7,
    name: "What A Time To Be Alive",
    tag: "Judith Garcia",
    cover: "../images/b3.jpg",
  },
  {
    id: 8,
    name: "Live Radio",
    tag: "Radionomy",
    cover: "../images/b5.jpg",
  },
  {
    id: 1,
    name: "Simple Place To Be",
    tag: "RYD",
    cover: "../images/b1.jpg",
  },
  {
    id: 2,
    name: "Reflection (Deluxe)",
    tag: "Fifth Harmony",
    cover: "../images/b2.jpg",
  },
  {
    id: 3,
    name: "The Open Road",
    tag: "Postiljonen",
    cover: "../images/b3.jpg",
  },
  {
    id: 4,
    name: "Body on me",
    tag: "Rita Ora",
    cover: "../images/b4.jpg",
  },
  {
    id: 5,
    name: "I Wanna Be In the Cavalry",
    tag: "Jeremy Scott",
    cover: "../images/b5.jpg",
  },
  {
    id: 6,
    name: "Pull Up",
    tag: "Summerella",
    cover: "../images/b6.jpg",
  },
  {
    id: 7,
    name: "What A Time To Be Alive",
    tag: "Judith Garcia",
    cover: "../images/b7.jpg",
  },
  {
    id: 8,
    name: "Live Radio",
    tag: "Radionomy",
    cover: "../images/b8.jpg",
  },
  {
    id: 9,
    name: "What A Time To Be Alive",
    tag: "Judith Garcia",
    cover: "../images/b3.jpg",
  },
  {
    id: 10,
    name: "Live Radio",
    tag: "Radionomy",
    cover: "../images/b2.jpg",
  },
  {
    id: 1,
    name: "Simple Place To Be",
    tag: "RYD",
    cover: "../images/b7.jpg",
  },
  {
    id: 2,
    name: "Reflection (Deluxe)",
    tag: "Fifth Harmony",
    cover: "../images/b8.jpg",
  },
  {
    id: 3,
    name: "The Open Road",
    tag: "Postiljonen",
    cover: "../images/b9.jpg",
  },
  {
    id: 4,
    name: "Body on me",
    tag: "Rita Ora",
    cover: "../images/b6.jpg",
  },
  {
    id: 5,
    name: "I Wanna Be In the Cavalry",
    tag: "Jeremy Scott",
    cover: "../images/b2.jpg",
  },
  {
    id: 6,
    name: "Pull Up",
    tag: "Summerella",
    cover: "../images/b4.jpg",
  },
  {
    id: 7,
    name: "What A Time To Be Alive",
    tag: "Judith Garcia",
    cover: "../images/b3.jpg",
  },
  {
    id: 8,
    name: "Live Radio",
    tag: "Radionomy",
    cover: "../images/b5.jpg",
  },
]
